// extracted by mini-css-extract-plugin
export default {"cta":"hG-z","disabled":"iG-z"};